/**
 * Cart Drawer — Product Recommendations Upsell
 * Uses MutationObserver to detect drawer open and re-render,
 * then injects upsell recommendations dynamically.
 */
(function () {
  var currentProductId = null;
  var loading = false;

  function getContainer() {
    return document.getElementById('CartDrawer-Upsell');
  }

  function injectContainer() {
    var existing = getContainer();
    if (existing) return existing;

    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (!ctas) return null;

    var wrapper = document.createElement('div');
    wrapper.id = 'CartDrawer-Upsell';
    wrapper.className = 'pp-upsell';
    wrapper.style.display = 'none';
    wrapper.innerHTML = '<h3 class="pp-upsell__heading">You may also like</h3><div class="pp-upsell__products"></div>';
    ctas.parentNode.insertBefore(wrapper, ctas);
    return wrapper;
  }

  async function load() {
    if (loading) return;
    loading = true;

    try {
      var container = injectContainer();
      if (!container) { loading = false; return; }
      var productsEl = container.querySelector('.pp-upsell__products');
      if (!productsEl) { loading = false; return; }

      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      var cart = await res.json();

      if (!cart.items || cart.items.length === 0) {
        container.style.display = 'none';
        loading = false;
        return;
      }

      var productId = cart.items[0].product_id;

      var cartProductIds = {};
      cart.items.forEach(function (item) {
        cartProductIds[item.product_id] = true;
      });

      var recRes = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=4');
      var data = await recRes.json();

      if (!data.products || data.products.length === 0) {
        container.style.display = 'none';
        loading = false;
        return;
      }

      var products = data.products.filter(function (p) {
        return !cartProductIds[p.id];
      }).slice(0, 1);

      if (products.length === 0) {
        container.style.display = 'none';
        loading = false;
        return;
      }

      currentProductId = productId;
      render(productsEl, products);
      container.style.display = '';
    } catch (e) {
      // silently fail
    }
    loading = false;
  }

  function render(productsEl, products) {
    var html = '';

    products.forEach(function (product) {
      var image = product.featured_image || product.images[0];
      var imageUrl = image ? image.replace(/(\.[^.]+)$/, '_160x160_crop_center$1') : '';
      var price = (product.price / 100).toFixed(2);
      var variantId = product.variants[0].id;
      var url = product.url;

      html += '<div class="pp-upsell__card">' +
        '<a href="' + url + '" class="pp-upsell__image-link">' +
          '<img class="pp-upsell__img" src="' + imageUrl + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="80" height="80">' +
        '</a>' +
        '<div class="pp-upsell__info">' +
          '<a href="' + url + '" class="pp-upsell__title">' + product.title + '</a>' +
          '<span class="pp-upsell__price">$' + price + '</span>' +
          '<button class="pp-upsell__add" data-variant-id="' + variantId + '">Add to Cart</button>' +
        '</div>' +
      '</div>';
    });

    productsEl.innerHTML = html;

    var buttons = productsEl.querySelectorAll('.pp-upsell__add');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn.dataset.variantId, btn);
      });
    });
  }

  async function addToCart(variantId, btn) {
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      // Add the item
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });

      btn.textContent = 'Added!';
      currentProductId = null;

      // Fetch updated drawer and cart icon sections from Shopify (same as Dawn does)
      var sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      var sections = await sectionsRes.json();

      // Update cart icon bubble
      if (sections['cart-icon-bubble']) {
        var bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-icon-bubble'];
          var newBubble = tmp.querySelector('.shopify-section');
          if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
        }
      }

      // Update cart drawer contents
      if (sections['cart-drawer']) {
        var drawerTarget = document.getElementById('CartDrawer');
        if (drawerTarget) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = sections['cart-drawer'];
          var newDrawer = tmp2.querySelector('#CartDrawer');
          if (newDrawer) {
            drawerTarget.innerHTML = newDrawer.innerHTML;

            // Re-bind the overlay close button
            var overlay = drawerTarget.querySelector('#CartDrawer-Overlay');
            if (overlay) {
              overlay.addEventListener('click', function () {
                var drawer = document.querySelector('cart-drawer');
                if (drawer && drawer.close) drawer.close();
              });
            }
          }
        }
      }

      // Update shipping bar
      if (window.ppShippingBar) {
        setTimeout(function () { window.ppShippingBar.update(); }, 200);
      }

      // Re-inject and reload upsell after drawer re-render
      setTimeout(function () {
        loading = false;
        load();
      }, 300);

    } catch (e) {
      btn.textContent = 'Error';
      setTimeout(function () {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);
    }
  }

  function tryLoad() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      load();
    }
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Watch <cart-drawer> for class changes (active = open) AND child changes (re-render)
    var observer = new MutationObserver(function (mutations) {
      var shouldLoad = false;
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (drawer.classList.contains('active')) {
            shouldLoad = true;
          }
        }
        if (m.type === 'childList') {
          if (drawer.classList.contains('active') && !getContainer()) {
            shouldLoad = true;
          }
        }
      });
      if (shouldLoad) {
        setTimeout(tryLoad, 300);
      }
    });
    observer.observe(drawer, { attributes: true, childList: true, subtree: true });

    // Also watch for cart icon clicks as a backup
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble')) {
        setTimeout(tryLoad, 400);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
